import React, { useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

export function AuthGuard({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let redirectTimeout;
    let hasRedirected = false;

    // 현재 세션 확인
    const checkSession = async () => {
      try {
        const { data: { session }, error } = await supabase.auth.getSession();
        
        console.log('AuthGuard - Session check:', { session, error });
        
        if (!session && !hasRedirected) {
          // 세션이 없을 때 약간의 딜레이 후 재확인 (쿠키 로딩 시간)
          redirectTimeout = setTimeout(async () => {
            const { data: { session: retrySession } } = await supabase.auth.getSession();
            
            if (!retrySession && !hasRedirected) {
              hasRedirected = true;
              console.log('No session found, redirecting to auth...');
              const currentUrl = window.location.href;
              window.location.href = `https://auth.sayberrygames.com?redirect_to=${encodeURIComponent(currentUrl)}`;
            } else if (retrySession) {
              console.log('Session found on retry');
              setAuthenticated(true);
              setLoading(false);
            }
          }, 1500); // 1.5초 대기
        } else if (session) {
          console.log('Session found immediately');
          setAuthenticated(true);
          setLoading(false);
        }
      } catch (error) {
        console.error('Session check error:', error);
      }
    };

    checkSession();

    // 인증 상태 변경 감지
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      console.log('Auth state changed:', event, session);
      
      if (event === 'SIGNED_OUT' || (!session && event !== 'USER_UPDATED')) {
        if (!hasRedirected) {
          hasRedirected = true;
          const currentUrl = window.location.href;
          window.location.href = `https://auth.sayberrygames.com?redirect_to=${encodeURIComponent(currentUrl)}`;
        }
      } else if (session) {
        setAuthenticated(true);
        setLoading(false);
      }
    });

    return () => {
      if (redirectTimeout) clearTimeout(redirectTimeout);
      subscription.unsubscribe();
    };
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        backgroundColor: '#0f0f0f',
        color: '#fff'
      }}>
        <div>인증 확인 중...</div>
      </div>
    );
  }

  return authenticated ? children : null;
}